import React from 'react';
import { useNavigate } from 'react-router-dom';

const sectors = [
  {
    icon: '🏢',
    title: 'Commercial Construction',
    desc: 'From city centre offices to retail parks, we supply skilled teams for commercial projects of all sizes.',
    roles: ['Site Managers & Foremen', 'M&E Engineers', 'Drylining Specialists', 'Ceiling Fixers', 'Shopfitting Specialists', 'Commercial Electricians'],
  },
  {
    icon: '🏠',
    title: 'Residential Development',
    desc: 'Supporting housebuilders and developers with quality tradespeople and site staff for volume and bespoke housing projects.',
    roles: ['Bricklayers', 'Carpenters', 'Groundworkers', 'Plasterers', 'Roofers', 'Site Managers', 'New Homes Sales Advisors'],
  },
  {
    icon: '🌉',
    title: 'Infrastructure & Civil Engineering',
    desc: 'Major infrastructure demands specialist skills. We recruit for highways, rail, utilities, and major civil projects.',
    roles: ['Civil Engineers', 'Setting Out Engineers', 'Highways Operatives', 'Pipe Layers', 'Plant Operators', 'Traffic Management', 'Quantity Surveyors'],
  },
  {
    icon: '🏭',
    title: 'Industrial & Manufacturing',
    desc: 'Industrial facilities require specific expertise in mechanical and electrical systems, process engineering, and plant operations.',
    roles: ['Industrial Electricians', 'Mechanical Fitters', 'Welders & Fabricators', 'HVAC Engineers', 'Process Engineers', 'Maintenance Engineers'],
  },
  {
    icon: '🔧',
    title: 'Facilities Management',
    desc: 'Ongoing building maintenance and management requires reliable, multi-skilled professionals.',
    roles: ['Maintenance Technicians', 'Building Managers', 'Cleaners & Porters', 'Security Personnel', 'Caretakers', 'Handypersons'],
  },
  {
    icon: '⚙️',
    title: 'Specialist Trades',
    desc: 'Niche skills for specific project requirements across all construction sectors.',
    roles: ['Scaffolding', 'Demolition', 'Asbestos Removal', 'Heritage & Restoration', 'Groundworks & Piling', 'Cladding & Facades', 'Tunnelling', 'Waterproofing'],
  },
];

export default function SectorsPage() {
  const navigate = useNavigate();

  return (
    <div>
      {/* Page Hero */}
      <section className="page-hero">
        <div className="container">
          <h1>Construction Sectors</h1>
          <p>Specialist recruitment across all major construction sectors</p>
          <div className="breadcrumb">
            <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }}>Home</a>
            <span>/</span>
            <span style={{ color: 'rgba(255,255,255,0.9)' }}>Sectors</span>
          </div>
        </div>
      </section>

      {/* Sectors */}
      {sectors.map((sector, idx) => (
        <section className={idx % 2 === 0 ? 'section' : 'section-alt'} key={idx}>
          <div className="container">
            <div className="grid grid-2" style={{ alignItems: 'start', gap: '50px' }}>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
                  <span style={{ fontSize: '3rem' }}>{sector.icon}</span>
                  <h2 style={{ margin: 0 }}>{sector.title}</h2>
                </div>
                <p style={{ fontSize: '1.05rem', lineHeight: '1.8' }}>{sector.desc}</p>
                <div style={{ marginTop: '20px' }}>
                  <button className="btn btn-outline-accent btn-sm" onClick={() => navigate('/jobs')}>
                    View {sector.title} Jobs →
                  </button>
                </div>
              </div>
              <div>
                <div className="card">
                  <h4 style={{ marginBottom: '15px' }}>Key Roles We Fill</h4>
                  <ul className="card-list">
                    {sector.roles.map((r, i) => (
                      <li key={i}>{r}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* CTA */}
      <section className="cta-banner">
        <div className="container">
          <h2>Need Sector-Specific Talent?</h2>
          <p>Our specialists understand the unique requirements of each construction sector.</p>
          <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button className="btn btn-secondary btn-lg" onClick={() => navigate('/contact')}>
              Speak to a Specialist
            </button>
            <button className="btn btn-dark btn-lg" onClick={() => navigate('/jobs')}>
              Browse All Jobs
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
